<template>
  <div v-if="FooterData">
    <!-- 浮動選單 -->
    <ul :class="['float_menu', { 'add': isFloat }]" v-if="FooterData.Right_Menu">
      <li v-for="(MenuData, index) in FooterData.Right_Menu" :key="index">
        <a :href="getLink(MenuData.Menu)" :target="MenuData.Menu.Type == 3 && MenuData.Menu.Blank ? '_blank' : ''"
          :title="MenuData.Menu.Title + (MenuData.Menu.Type == 3 && MenuData.Menu.Blank ? ', 另開新視窗' : '')">
          <img :src="FooterData.SiteUrl + MenuData.Menu.Image" :alt="MenuData.Menu.Title">
        </a>
      </li>
    </ul>
    <!-- 音樂節的頁尾(其他頁面父層是.festival) -->
    <div class="festival_footer">
      <div class="container">
        <div class="history_festival">
          <ul class="list">
            <li class="title">
              <p>歷屆音樂節</p>
            </li>
            <!-- 使用 v-for 遍歷歷屆音樂節的列表 -->
            <li v-for="(MenuData, index) in FooterData.FestivalHistory_Menu" :key="index">
              <a v-if="MenuData.Menu.Type == 1 || MenuData.Menu.Type == 2" :href="getLink(MenuData.Menu)"
                :title="MenuData.Menu.Title">{{
                  MenuData.Menu.Title }}</a>
              <a v-if="MenuData.Menu.Type == 3" :href="getLink(MenuData.Menu)"
                :title="MenuData.Menu.Title + (MenuData.Menu.Blank ? ', 另開新視窗' : '')"
                :target="MenuData.Menu.Blank ? '_blank' : ''">{{
                  MenuData.Menu.Title }}</a>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- 頒獎典禮的頁尾(其他頁面父層是.awards) -->
    <div class="design_img">
      <!-- <img :src="FooterData.SiteLogo" alt="GMA logo" v-if="FooterData.SiteLogo"> -->
      <img src="img/GMAlogo.svg" alt="GMA logo" v-if="FooterData.SiteLogo">
      <img src="img/GAMlogo.svg" alt="GMA logo" v-else>
    </div>

    <!-- 兩個都有的頁尾 -->
    <div class="footer">
      <a accesskey="b" id="accesskey_b" href="#" title="下方為合作單位區塊">
        :::
      </a>
      <div class="container">
        <ul class="list" v-if="FooterData.Links_Menu">
          <li v-for="(MenuData, index) in FooterData.Links_Menu" :key="index"
            :class="{ 'basis_100': MenuData.SubMenus }">
            <p>{{ MenuData.Menu.Title }}</p>
            <div v-if="MenuData.SubMenus">
              <div v-for="(SubMenu, index_sub) in MenuData.SubMenus" :key="index_sub">
                <img :src="FooterData.SiteUrl + SubMenu.Image" :alt="SubMenu.Title" />
              </div>
            </div>
            <div v-else>
              <img :src="FooterData.SiteUrl + MenuData.Menu.Image" :alt="MenuData.Menu.Title" />
            </div>
          </li>
        </ul>
        <div v-if="FooterData.Footer_Text" v-html="FooterData.Footer_Text">
        </div>
      </div>
    </div>
    <div :class="['top_box', { 'add': isTop }]">
      <button @click="scrollToTop()" class="top_btn">
        <p>TOP</p>
      </button>
      <img class="top_bg" src="img/bg_top.svg" alt="">
    </div>
  </div>
</template>

<script>
import Vue from "vue";

import axios from "axios";
import VueAxios from "vue-axios";
Vue.use(VueAxios, axios);

import VueI18n from "vue-i18n";
Vue.use(VueI18n);

//import { Fragment } from 'vue-fragment'

const messages = {
  zh_tw: {
  },
  en: {
  },
};

const i18n = new VueI18n({
  locale: "zh_tw",
  messages,
});

import AES from "@/utils/aes.js";
import Validate from "@/utils/validate.js";

import Slick from "vue-slick";

export default {
  name: "FooterBlock",
  i18n,
  components: {
    //Fragment,
    Slick,
  },
  data() {
    return {
      FooterData: null,
      isFloat: false,
      isTop: false,
      local: "zh_tw",
    };
  },
  created: function () {
    // Vue.axios
    //   .get(
    //     this.$store.state.src + this.$store.state.subDirectory + "/Html/Footer",
    //     {
    //       params: { lang: $cookies.get("gma_the_site_lang") },
    //     }
    //   )
    //   .then((response) => {
    //     this.FooterData = response.data;
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //   });
    if ($cookies.get("gma_the_site_lang") == "zh_tw") {
      this.FooterData = {
        "SiteUrl": "https://tavis.tw/gma/36th",
        "SiteLogo": "https://tavis.tw/gma/36th/Upload/Editor/95635b33-f644-44a6-9371-dc4a6ecaa672.webp",
        "FestivalHistory_Menu": [
          {
            "Menu": {
              "MLIId": 116,
              "MLId": 12,
              "Id": "488bf154-263d-49a2-882a-3e5965859a85",
              "ParentId": "root",
              "Title": "2024",
              "Description": "",
              "IsVisable": true,
              "Image": "",
              "Color": "",
              "Type": 3,
              "CId": -1,
              "PId": -1,
              "Url": "https://tavis.tw/gma/35th/",
              "Blank": true,
              "Sort": 1,
              "CreateTime": "2025-04-02T08:32:46.74",
              "LastEditTime": "2025-04-17T12:00:14.463",
              "IsWinner": false
            },
            "SubMenus": null
          },
          {
            "Menu": {
              "MLIId": 117,
              "MLId": 12,
              "Id": "e640199e-4ee0-4607-b962-9f9d4ee9586a",
              "ParentId": "root",
              "Title": "2023",
              "Description": "",
              "IsVisable": true,
              "Image": "",
              "Color": "",
              "Type": 3,
              "CId": -1,
              "PId": -1,
              "Url": "https://tavis.tw/gma/34th/",
              "Blank": true,
              "Sort": 2,
              "CreateTime": "2025-04-02T08:32:57.107",
              "LastEditTime": "2025-04-17T12:00:14.463",
              "IsWinner": false
            },
            "SubMenus": null
          },
          {
            "Menu": {
              "MLIId": 118,
              "MLId": 12,
              "Id": "64d5267c-df32-4f28-a926-ecb3dee0a802",
              "ParentId": "root",
              "Title": "2022",
              "Description": "",
              "IsVisable": true,
              "Image": "",
              "Color": "",
              "Type": 3,
              "CId": -1,
              "PId": -1,
              "Url": "https://tavis.tw/gma/33rd/",
              "Blank": true,
              "Sort": 3,
              "CreateTime": "2025-04-02T08:33:02.217",
              "LastEditTime": "2025-04-17T12:00:14.463",
              "IsWinner": false
            },
            "SubMenus": null
          },
          {
            "Menu": {
              "MLIId": 198,
              "MLId": 12,
              "Id": "d434194e-546d-47e8-98d0-cbc38a3205a4",
              "ParentId": "root",
              "Title": "2021",
              "Description": "",
              "IsVisable": true,
              "Image": "",
              "Color": "",
              "Type": 3,
              "CId": -1,
              "PId": -1,
              "Url": "https://tavis.tw/gma/32nd/",
              "Blank": true,
              "Sort": 4,
              "CreateTime": "2025-04-17T11:53:24.247",
              "LastEditTime": "2025-04-17T12:00:14.463",
              "IsWinner": false
            },
            "SubMenus": null
          },
          {
            "Menu": {
              "MLIId": 199,
              "MLId": 12,
              "Id": "12e0f667-8def-4e8f-978f-9831ed7e2820",
              "ParentId": "root",
              "Title": "2020",
              "Description": "",
              "IsVisable": true,
              "Image": "",
              "Color": "",
              "Type": 3,
              "CId": -1,
              "PId": -1,
              "Url": "https://tavis.tw/gma/31st/GMA/default.htm",
              "Blank": true,
              "Sort": 5,
              "CreateTime": "2025-04-17T11:55:00.323",
              "LastEditTime": "2025-04-17T12:00:14.463",
              "IsWinner": false
            },
            "SubMenus": null
          },
          {
            "Menu": {
              "MLIId": 200,
              "MLId": 12,
              "Id": "2a1680aa-f06e-4e68-b0ab-b39b85e9e318",
              "ParentId": "root",
              "Title": "2019",
              "Description": "",
              "IsVisable": true,
              "Image": "",
              "Color": "",
              "Type": 3,
              "CId": -1,
              "PId": -1,
              "Url": "https://tavis.tw/gma/30th/",
              "Blank": true,
              "Sort": 6,
              "CreateTime": "2025-04-17T11:55:56.143",
              "LastEditTime": "2025-04-17T12:00:14.48",
              "IsWinner": false
            },
            "SubMenus": null
          },
          {
            "Menu": {
              "MLIId": 201,
              "MLId": 12,
              "Id": "953e6d41-8e7a-4457-93fa-cbff48298c17",
              "ParentId": "root",
              "Title": "2018",
              "Description": "",
              "IsVisable": true,
              "Image": "",
              "Color": "",
              "Type": 3,
              "CId": -1,
              "PId": -1,
              "Url": "https://tavis.tw/gma/29th/",
              "Blank": true,
              "Sort": 7,
              "CreateTime": "2025-04-17T11:57:00.617",
              "LastEditTime": "2025-04-17T12:00:14.48",
              "IsWinner": false
            },
            "SubMenus": null
          },
          {
            "Menu": {
              "MLIId": 202,
              "MLId": 12,
              "Id": "6b9ca94d-3ed0-4991-b3a7-a7f8db71825c",
              "ParentId": "root",
              "Title": "2017",
              "Description": "",
              "IsVisable": true,
              "Image": "",
              "Color": "",
              "Type": 3,
              "CId": -1,
              "PId": -1,
              "Url": "https://tavis.tw/gma/28th/",
              "Blank": true,
              "Sort": 8,
              "CreateTime": "2025-04-17T11:57:20.81",
              "LastEditTime": "2025-04-17T12:00:14.48",
              "IsWinner": false
            },
            "SubMenus": null
          },
          {
            "Menu": {
              "MLIId": 203,
              "MLId": 12,
              "Id": "225a70f1-85bc-4f62-b485-d467d29c079d",
              "ParentId": "root",
              "Title": "2016",
              "Description": "",
              "IsVisable": true,
              "Image": "",
              "Color": "",
              "Type": 3,
              "CId": -1,
              "PId": -1,
              "Url": "https://tavis.tw/gma/27th/",
              "Blank": true,
              "Sort": 9,
              "CreateTime": "2025-04-17T11:57:49.18",
              "LastEditTime": "2025-04-17T12:00:14.48",
              "IsWinner": false
            },
            "SubMenus": null
          },
          {
            "Menu": {
              "MLIId": 204,
              "MLId": 12,
              "Id": "96fd90be-d641-44d7-8ff6-6cefa62457b1",
              "ParentId": "root",
              "Title": "2015",
              "Description": "",
              "IsVisable": true,
              "Image": "",
              "Color": "",
              "Type": 3,
              "CId": -1,
              "PId": -1,
              "Url": "https://tavis.tw/gma/26th/",
              "Blank": true,
              "Sort": 10,
              "CreateTime": "2025-04-17T11:58:33.887",
              "LastEditTime": "2025-04-17T12:00:14.48",
              "IsWinner": false
            },
            "SubMenus": null
          },
          {
            "Menu": {
              "MLIId": 205,
              "MLId": 12,
              "Id": "52051bc3-725b-48a0-abaf-2ca8203febf4",
              "ParentId": "root",
              "Title": "2014",
              "Description": "",
              "IsVisable": true,
              "Image": "",
              "Color": "",
              "Type": 3,
              "CId": -1,
              "PId": -1,
              "Url": "https://tavis.tw/gma/25th/",
              "Blank": true,
              "Sort": 11,
              "CreateTime": "2025-04-17T11:59:10.21",
              "LastEditTime": "2025-04-17T12:00:14.48",
              "IsWinner": false
            },
            "SubMenus": null
          }
        ],
        "Links_Menu": [
          {
            "Menu": {
              "MLIId": 292,
              "MLId": 21,
              "Id": "e033d416-7d05-40e4-a893-bafdeb43b743",
              "ParentId": "root",
              "Title": "主辦單位 Organizer",
              "Description": "",
              "IsVisable": true,
              "Image": "/Upload/Editor/d00bfa9e-4a80-49d8-bfa1-8e59574f0105.webp",
              "Color": "",
              "Type": 0,
              "CId": -1,
              "PId": -1,
              "Url": "https://www.bamid.gov.tw/#",
              "Blank": true,
              "Sort": 1,
              "CreateTime": "2025-04-30T13:37:24.387",
              "LastEditTime": "2025-06-06T03:58:27.863",
              "IsWinner": false
            },
            "SubMenus": null
          },
          {
            "Menu": {
              "MLIId": 302,
              "MLId": 21,
              "Id": "80b209fd-e5b7-481d-b385-6c223e6db256",
              "ParentId": "root",
              "Title": "合辦單位 Co-organizer",
              "Description": "",
              "IsVisable": true,
              "Image": "",
              "Color": "",
              "Type": 0,
              "CId": -1,
              "PId": -1,
              "Url": "",
              "Blank": false,
              "Sort": 2,
              "CreateTime": "2025-04-30T14:59:59.12",
              "LastEditTime": "2025-06-06T03:58:27.87",
              "IsWinner": false
            },
            "SubMenus": [
              {
                "MLIId": 312,
                "MLId": 21,
                "Id": "c7fa1429-0dff-4685-ae12-ba87ba66edc8",
                "ParentId": "80b209fd-e5b7-481d-b385-6c223e6db256",
                "Title": "文化部",
                "Description": "",
                "IsVisable": true,
                "Image": "/Upload/Editor/22592b37-faef-4f83-bea5-9490a4ba9a25.webp",
                "Color": "",
                "Type": 0,
                "CId": -1,
                "PId": -1,
                "Url": "",
                "Blank": false,
                "Sort": 3,
                "CreateTime": "2025-04-30T16:17:37.307",
                "LastEditTime": "2025-06-06T03:58:27.873",
                "IsWinner": false
              },
              {
                "MLIId": 306,
                "MLId": 21,
                "Id": "d43292fa-2577-4c16-b269-270f089b0c66",
                "ParentId": "80b209fd-e5b7-481d-b385-6c223e6db256",
                "Title": "文化局",
                "Description": "",
                "IsVisable": true,
                "Image": "/Upload/Editor/6d88e366-5e56-4b8b-9228-af3ff523a89d.webp",
                "Color": "",
                "Type": 0,
                "CId": -1,
                "PId": -1,
                "Url": "",
                "Blank": false,
                "Sort": 4,
                "CreateTime": "2025-04-30T15:01:23.63",
                "LastEditTime": "2025-06-06T03:58:27.88",
                "IsWinner": false
              }
            ]
          },
          {
            "Menu": {
              "MLIId": 303,
              "MLId": 21,
              "Id": "184ecc65-1cf8-44e2-a751-866b5d55cec4",
              "ParentId": "root",
              "Title": "承辦單位 Executive organizer",
              "Description": "",
              "IsVisable": true,
              "Image": "/Upload/Editor/77028d94-231e-4ec5-93ed-e5f83dcd1db5.webp",
              "Color": "",
              "Type": 0,
              "CId": -1,
              "PId": -1,
              "Url": "",
              "Blank": false,
              "Sort": 5,
              "CreateTime": "2025-04-30T15:00:01.947",
              "LastEditTime": "2025-06-06T03:58:27.887",
              "IsWinner": false
            },
            "SubMenus": null
          },
          {
            "Menu": {
              "MLIId": 304,
              "MLId": 21,
              "Id": "97218e33-6754-49c2-9872-0dcecb0d9bbf",
              "ParentId": "root",
              "Title": "典禮製作統籌 Ceremony Production",
              "Description": "",
              "IsVisable": true,
              "Image": "/Upload/Editor/331fc1a9-8f8f-45c2-a1c9-71964491b100.webp",
              "Color": "",
              "Type": 0,
              "CId": -1,
              "PId": -1,
              "Url": "",
              "Blank": false,
              "Sort": 6,
              "CreateTime": "2025-04-30T15:00:23.287",
              "LastEditTime": "2025-06-06T03:58:27.89",
              "IsWinner": false
            },
            "SubMenus": null
          },
          {
            "Menu": {
              "MLIId": 622,
              "MLId": 21,
              "Id": "8fad3ba1-7473-4f89-824e-c65754f7d323",
              "ParentId": "root",
              "Title": "金曲官方直播 GMA Official Live Stream",
              "Description": "",
              "IsVisable": true,
              "Image": "",
              "Color": "",
              "Type": 0,
              "CId": -1,
              "PId": -1,
              "Url": "",
              "Blank": false,
              "Sort": 7,
              "CreateTime": "2025-06-02T07:07:02.283",
              "LastEditTime": "2025-06-06T03:58:27.897",
              "IsWinner": false
            },
            "SubMenus": [
              {
                "MLIId": 621,
                "MLId": 21,
                "Id": "ba071d0f-4283-46da-874f-1d59086bc7f7",
                "ParentId": "8fad3ba1-7473-4f89-824e-c65754f7d323",
                "Title": "金曲YOUTUBE",
                "Description": "",
                "IsVisable": true,
                "Image": "/Upload/Editor/d1ad0ff0-fe3e-4d65-8ac1-f0e4717f86f7.webp",
                "Color": "",
                "Type": 0,
                "CId": -1,
                "PId": -1,
                "Url": "",
                "Blank": false,
                "Sort": 8,
                "CreateTime": "2025-06-02T07:03:37.123",
                "LastEditTime": "2025-06-06T03:58:27.903",
                "IsWinner": false
              }
            ]
          },
          {
            "Menu": {
              "MLIId": 367,
              "MLId": 21,
              "Id": "fef47c50-e5ee-4b0b-8a4e-988393b58363",
              "ParentId": "root",
              "Title": "直播平台 Live Streaming Platform",
              "Description": "",
              "IsVisable": true,
              "Image": "",
              "Color": "",
              "Type": 0,
              "CId": -1,
              "PId": -1,
              "Url": "",
              "Blank": false,
              "Sort": 9,
              "CreateTime": "2025-05-08T10:23:58.34",
              "LastEditTime": "2025-06-06T03:58:27.907",
              "IsWinner": false
            },
            "SubMenus": [
              {
                "MLIId": 375,
                "MLId": 21,
                "Id": "8bc38d80-5ca4-4525-aa26-ad52f1cc0ffc",
                "ParentId": "fef47c50-e5ee-4b0b-8a4e-988393b58363",
                "Title": "LINE TODAY",
                "Description": "",
                "IsVisable": true,
                "Image": "/Upload/Editor/440c055e-09be-4b78-af12-b850752528b0.webp",
                "Color": "",
                "Type": 0,
                "CId": -1,
                "PId": -1,
                "Url": "",
                "Blank": false,
                "Sort": 10,
                "CreateTime": "2025-05-08T12:10:01.827",
                "LastEditTime": "2025-06-06T03:58:27.913",
                "IsWinner": false
              },
              {
                "MLIId": 376,
                "MLId": 21,
                "Id": "161c5554-871c-450a-9014-82e8380a61c0",
                "ParentId": "fef47c50-e5ee-4b0b-8a4e-988393b58363",
                "Title": "LINE MUSIC",
                "Description": "",
                "IsVisable": true,
                "Image": "/Upload/Editor/77ac3551-ba2c-4038-8b79-ea6a454d666a.webp",
                "Color": "",
                "Type": 0,
                "CId": -1,
                "PId": -1,
                "Url": "",
                "Blank": false,
                "Sort": 11,
                "CreateTime": "2025-05-08T12:10:02.31",
                "LastEditTime": "2025-06-06T03:58:27.92",
                "IsWinner": false
              }
            ]
          },
          {
            "Menu": {
              "MLIId": 368,
              "MLId": 21,
              "Id": "8e303015-2dba-42a3-93b0-600083da4f78",
              "ParentId": "root",
              "Title": "金曲指定電信 Designated Telecom",
              "Description": "",
              "IsVisable": true,
              "Image": "/Upload/Editor/68777809-8e1c-482a-9305-becc6685828e.webp",
              "Color": "",
              "Type": 0,
              "CId": -1,
              "PId": -1,
              "Url": "",
              "Blank": false,
              "Sort": 12,
              "CreateTime": "2025-05-08T10:23:59.213",
              "LastEditTime": "2025-06-06T03:58:27.927",
              "IsWinner": false
            },
            "SubMenus": null
          },
          {
            "Menu": {
              "MLIId": 369,
              "MLId": 21,
              "Id": "372354e5-2c1b-42b6-a0ea-e305c65d76f8",
              "ParentId": "root",
              "Title": "金曲指定禮車 Designated Limousine",
              "Description": "",
              "IsVisable": true,
              "Image": "/Upload/Editor/7abfc1ca-0fef-4950-a656-b7a8aca9e2f6.webp",
              "Color": "",
              "Type": 0,
              "CId": -1,
              "PId": -1,
              "Url": "",
              "Blank": false,
              "Sort": 13,
              "CreateTime": "2025-05-08T10:24:00.527",
              "LastEditTime": "2025-06-06T03:58:27.93",
              "IsWinner": false
            },
            "SubMenus": null
          },
          {
            "Menu": {
              "MLIId": 370,
              "MLId": 21,
              "Id": "9a3c3e59-0a9b-4974-a931-f383a9b6c37d",
              "ParentId": "root",
              "Title": "金曲指定航空 Designated Airline",
              "Description": "",
              "IsVisable": true,
              "Image": "/Upload/Editor/6f286a79-a007-4db4-95bb-28a4e7394fa1.webp",
              "Color": "",
              "Type": 0,
              "CId": -1,
              "PId": -1,
              "Url": "",
              "Blank": false,
              "Sort": 14,
              "CreateTime": "2025-05-08T10:24:01.2",
              "LastEditTime": "2025-06-06T03:58:27.937",
              "IsWinner": false
            },
            "SubMenus": null
          },
          {
            "Menu": {
              "MLIId": 371,
              "MLId": 21,
              "Id": "30b5f177-cc57-46ff-800f-ead3676610a2",
              "ParentId": "root",
              "Title": "聯合贊助 Co-sponsors",
              "Description": "",
              "IsVisable": true,
              "Image": "",
              "Color": "",
              "Type": 0,
              "CId": -1,
              "PId": -1,
              "Url": "",
              "Blank": false,
              "Sort": 15,
              "CreateTime": "2025-05-08T10:24:01.963",
              "LastEditTime": "2025-06-06T03:58:27.943",
              "IsWinner": false
            },
            "SubMenus": [
              {
                "MLIId": 372,
                "MLId": 21,
                "Id": "9a0e0663-d60a-4730-8bf6-a7574ca33e49",
                "ParentId": "30b5f177-cc57-46ff-800f-ead3676610a2",
                "Title": "CITY PRIMA",
                "Description": "",
                "IsVisable": true,
                "Image": "/Upload/Editor/0593b5a6-d4cf-418a-aed3-bbed91e55107.webp",
                "Color": "",
                "Type": 0,
                "CId": -1,
                "PId": -1,
                "Url": "",
                "Blank": false,
                "Sort": 16,
                "CreateTime": "2025-05-08T10:28:23",
                "LastEditTime": "2025-06-06T03:58:27.95",
                "IsWinner": false
              },
              {
                "MLIId": 373,
                "MLId": 21,
                "Id": "aedc2a9f-7ca7-4f94-8ecf-e7b7ec64952a",
                "ParentId": "30b5f177-cc57-46ff-800f-ead3676610a2",
                "Title": "麥當勞",
                "Description": "",
                "IsVisable": true,
                "Image": "/Upload/Editor/11401ad2-dd15-43f1-b2b0-dece8f2c01aa.webp",
                "Color": "",
                "Type": 0,
                "CId": -1,
                "PId": -1,
                "Url": "",
                "Blank": false,
                "Sort": 17,
                "CreateTime": "2025-05-08T10:28:24.483",
                "LastEditTime": "2025-06-06T03:58:27.953",
                "IsWinner": false
              },
              {
                "MLIId": 374,
                "MLId": 21,
                "Id": "fa65160d-cb0d-44c4-9cca-801e201ec88f",
                "ParentId": "30b5f177-cc57-46ff-800f-ead3676610a2",
                "Title": "舒酸定",
                "Description": "",
                "IsVisable": true,
                "Image": "/Upload/Editor/4667e26d-dc71-42af-b5bd-d333acbf4e22.webp",
                "Color": "",
                "Type": 0,
                "CId": -1,
                "PId": -1,
                "Url": "",
                "Blank": false,
                "Sort": 18,
                "CreateTime": "2025-05-08T10:28:25.343",
                "LastEditTime": "2025-06-06T03:58:27.963",
                "IsWinner": false
              },
              {
                "MLIId": 784,
                "MLId": 21,
                "Id": "969ce67b-8bef-4231-88c3-c40d4c8727e9",
                "ParentId": "30b5f177-cc57-46ff-800f-ead3676610a2",
                "Title": "任天堂",
                "Description": "",
                "IsVisable": true,
                "Image": "/Upload/Editor/a43b4e2d-ce43-4107-a23d-b8029bc4157b.webp",
                "Color": "",
                "Type": 0,
                "CId": -1,
                "PId": -1,
                "Url": "",
                "Blank": false,
                "Sort": 19,
                "CreateTime": "2025-06-06T03:56:56.69",
                "LastEditTime": "2025-06-06T03:58:27.97",
                "IsWinner": false
              }
            ]
          },
          {
            "Menu": {
              "MLIId": 377,
              "MLId": 21,
              "Id": "050ac92c-efde-47bf-9af0-2142dd2816d7",
              "ParentId": "root",
              "Title": "媒體協辦 Media Collaborators",
              "Description": "",
              "IsVisable": true,
              "Image": "",
              "Color": "",
              "Type": 0,
              "CId": -1,
              "PId": -1,
              "Url": "",
              "Blank": false,
              "Sort": 20,
              "CreateTime": "2025-05-08T12:41:45.093",
              "LastEditTime": "2025-06-06T03:58:27.973",
              "IsWinner": false
            },
            "SubMenus": [
              {
                "MLIId": 378,
                "MLId": 21,
                "Id": "987cc9f3-cf5d-491b-86f3-db7b4a17cc14",
                "ParentId": "050ac92c-efde-47bf-9af0-2142dd2816d7",
                "Title": "非凡電視台",
                "Description": "",
                "IsVisable": true,
                "Image": "/Upload/Editor/977d5079-1889-452d-ad49-6888df05cfdc.webp",
                "Color": "",
                "Type": 0,
                "CId": -1,
                "PId": -1,
                "Url": "",
                "Blank": false,
                "Sort": 21,
                "CreateTime": "2025-05-08T12:41:53.84",
                "LastEditTime": "2025-06-06T03:58:27.98",
                "IsWinner": false
              },
              {
                "MLIId": 379,
                "MLId": 21,
                "Id": "25c570b6-de72-4315-8a6e-6635c91eb4b7",
                "ParentId": "050ac92c-efde-47bf-9af0-2142dd2816d7",
                "Title": "ICRT",
                "Description": "",
                "IsVisable": true,
                "Image": "/Upload/Editor/26270fcb-9e50-4b05-b3e0-cf06dbc2ffb0.webp",
                "Color": "",
                "Type": 0,
                "CId": -1,
                "PId": -1,
                "Url": "",
                "Blank": false,
                "Sort": 22,
                "CreateTime": "2025-05-08T12:42:08.32",
                "LastEditTime": "2025-06-06T03:58:27.983",
                "IsWinner": false
              }
            ]
          }
        ],
        "Festival_Links_Menu": [
          {
            "Menu": {
              "MLIId": 54,
              "MLId": 3,
              "Id": "bd298c6d-5f96-4244-88da-672203b0c4e7",
              "ParentId": "root",
              "Title": "主辦單位 Organizer",
              "Description": "",
              "IsVisable": true,
              "Image": "/Upload/Editor/856e8db5-2fe3-40e6-81d7-ede500d28dfb.webp",
              "Color": "",
              "Type": 0,
              "CId": -1,
              "PId": -1,
              "Url": "",
              "Blank": false,
              "Sort": 1,
              "CreateTime": "2025-03-31T09:52:31.29",
              "LastEditTime": "2025-05-13T01:26:02.94",
              "IsWinner": false
            },
            "SubMenus": null
          },
          {
            "Menu": {
              "MLIId": 55,
              "MLId": 3,
              "Id": "fac44f16-0cc8-4e56-b2cb-da631d44cc37",
              "ParentId": "root",
              "Title": "合辦單位 Co-organizer",
              "Description": "",
              "IsVisable": true,
              "Image": "/Upload/Editor/ba0b0fba-98f7-42d4-96e9-484f25be3cc0.webp",
              "Color": "",
              "Type": 0,
              "CId": -1,
              "PId": -1,
              "Url": "",
              "Blank": false,
              "Sort": 2,
              "CreateTime": "2025-03-31T10:05:57.683",
              "LastEditTime": "2025-05-13T01:26:02.943",
              "IsWinner": false
            },
            "SubMenus": null
          },
          {
            "Menu": {
              "MLIId": 56,
              "MLId": 3,
              "Id": "443628b8-f971-4728-8ba9-16f137340c11",
              "ParentId": "root",
              "Title": "承辦單位 Executive organizer",
              "Description": "",
              "IsVisable": true,
              "Image": "/Upload/Editor/05eea5e6-979a-4439-9355-ce65b8cb152a.webp",
              "Color": "",
              "Type": 0,
              "CId": -1,
              "PId": -1,
              "Url": "",
              "Blank": false,
              "Sort": 3,
              "CreateTime": "2025-03-31T10:06:13.607",
              "LastEditTime": "2025-05-13T01:26:02.95",
              "IsWinner": false
            },
            "SubMenus": null
          },
          {
            "Menu": {
              "MLIId": 62,
              "MLId": 3,
              "Id": "ac75acc2-0c9c-4f23-aeba-50b23ca8c764",
              "ParentId": "root",
              "Title": "金曲指定電信 Designated Telecom",
              "Description": "",
              "IsVisable": true,
              "Image": "/Upload/Editor/def46249-acde-4769-9d76-12c1819297e2.webp",
              "Color": "",
              "Type": 0,
              "CId": -1,
              "PId": -1,
              "Url": "",
              "Blank": false,
              "Sort": 4,
              "CreateTime": "2025-03-31T10:07:37.633",
              "LastEditTime": "2025-05-13T01:26:02.957",
              "IsWinner": false
            },
            "SubMenus": null
          },
          {
            "Menu": {
              "MLIId": 336,
              "MLId": 3,
              "Id": "02f93b3b-7e76-4c4d-b2a3-f42fe01eabf6",
              "ParentId": "root",
              "Title": "金曲指定航空 Designated Airline",
              "Description": "",
              "IsVisable": true,
              "Image": "/Upload/Editor/42602313-b343-460b-9469-5438cc28fa22.webp",
              "Color": "",
              "Type": 0,
              "CId": -1,
              "PId": -1,
              "Url": "",
              "Blank": false,
              "Sort": 5,
              "CreateTime": "2025-05-07T11:35:41.69",
              "LastEditTime": "2025-05-13T01:26:02.96",
              "IsWinner": false
            },
            "SubMenus": null
          },
          {
            "Menu": {
              "MLIId": 331,
              "MLId": 3,
              "Id": "333c466d-a8ab-4b20-8b19-55d19be1a2d2",
              "ParentId": "root",
              "Title": "媒體協辦 Media Collaborators",
              "Description": "",
              "IsVisable": true,
              "Image": "",
              "Color": "",
              "Type": 0,
              "CId": -1,
              "PId": -1,
              "Url": "",
              "Blank": false,
              "Sort": 9,
              "CreateTime": "2025-05-05T16:52:54.423",
              "LastEditTime": "2025-05-13T01:26:02.993",
              "IsWinner": false
            },
            "SubMenus": [
              {
                "MLIId": 332,
                "MLId": 3,
                "Id": "27e65ca6-6ba0-48b8-b2f2-7d58f4ffd943",
                "ParentId": "333c466d-a8ab-4b20-8b19-55d19be1a2d2",
                "Title": "非凡電視",
                "Description": "",
                "IsVisable": true,
                "Image": "/Upload/Editor/45584c82-f934-45cb-ad57-f7424bd3da04.webp",
                "Color": "",
                "Type": 0,
                "CId": -1,
                "PId": -1,
                "Url": "",
                "Blank": false,
                "Sort": 10,
                "CreateTime": "2025-05-05T17:08:40.42",
                "LastEditTime": "2025-05-13T01:26:03",
                "IsWinner": false
              },
              {
                "MLIId": 334,
                "MLId": 3,
                "Id": "6826b633-5141-44bf-bb3f-66d757e3ec86",
                "ParentId": "333c466d-a8ab-4b20-8b19-55d19be1a2d2",
                "Title": "ICRT",
                "Description": "",
                "IsVisable": true,
                "Image": "/Upload/Editor/7dd16cf4-a715-4098-b14b-fddfeb09ea33.webp",
                "Color": "",
                "Type": 0,
                "CId": -1,
                "PId": -1,
                "Url": "",
                "Blank": false,
                "Sort": 11,
                "CreateTime": "2025-05-05T17:08:50.297",
                "LastEditTime": "2025-05-13T01:26:03.007",
                "IsWinner": false
              }
            ]
          }
        ],
        "Right_Menu": [
          {
            "Menu": {
              "MLIId": 63,
              "MLId": 4,
              "Id": "01a8486d-8d8b-4da7-8386-f9a2cfc42c22",
              "ParentId": "root",
              "Title": "Facebook",
              "Description": "",
              "IsVisable": true,
              "Image": "/Upload/Editor/88b27330-b456-4f39-8a4a-75ed4f612537.svg",
              "Color": "",
              "Type": 3,
              "CId": -1,
              "PId": -1,
              "Url": "https://www.facebook.com/GMAGMF",
              "Blank": true,
              "Sort": 1,
              "CreateTime": "2025-03-31T10:08:36.087",
              "LastEditTime": "2025-04-30T14:10:02.67",
              "IsWinner": false
            },
            "SubMenus": null
          },
          {
            "Menu": {
              "MLIId": 64,
              "MLId": 4,
              "Id": "e7264c42-d9a2-46e5-85d8-b6651610b974",
              "ParentId": "root",
              "Title": "Youtube",
              "Description": "",
              "IsVisable": true,
              "Image": "/Upload/Editor/7bbcd1c0-6985-4584-803a-1e66aec01ed7.svg",
              "Color": "",
              "Type": 3,
              "CId": -1,
              "PId": -1,
              "Url": "https://www.youtube.com/channel/UC_r0QUJ6T4ZLaadqQcaA7qw",
              "Blank": true,
              "Sort": 2,
              "CreateTime": "2025-03-31T10:08:55.803",
              "LastEditTime": "2025-04-30T14:10:02.687",
              "IsWinner": false
            },
            "SubMenus": null
          },
          {
            "Menu": {
              "MLIId": 65,
              "MLId": 4,
              "Id": "733bb800-2d91-47c9-82e0-16db30c14c07",
              "ParentId": "root",
              "Title": "X",
              "Description": "",
              "IsVisable": true,
              "Image": "/Upload/Editor/ad94543c-3a93-444d-a891-824a6c21ed23.svg",
              "Color": "",
              "Type": 3,
              "CId": -1,
              "PId": -1,
              "Url": "https://twitter.com/GoldenMelody",
              "Blank": true,
              "Sort": 3,
              "CreateTime": "2025-03-31T10:09:09.1",
              "LastEditTime": "2025-04-30T14:10:02.687",
              "IsWinner": false
            },
            "SubMenus": null
          },
          {
            "Menu": {
              "MLIId": 66,
              "MLId": 4,
              "Id": "07c5eff5-5345-4d45-a276-60e65994ef43",
              "ParentId": "root",
              "Title": "IG",
              "Description": "",
              "IsVisable": true,
              "Image": "/Upload/Editor/ce224894-6171-41e5-93f8-b590fa203310.svg",
              "Color": "",
              "Type": 3,
              "CId": -1,
              "PId": -1,
              "Url": "https://www.instagram.com/gmamusic.official/?hl=zh-tw",
              "Blank": true,
              "Sort": 4,
              "CreateTime": "2025-03-31T10:09:24.147",
              "LastEditTime": "2025-04-30T14:10:02.687",
              "IsWinner": false
            },
            "SubMenus": null
          }
        ],
        "Footer_Text": "<div class=\"box\">\r\n<p>臺灣電視事業股份有限公司版權所有 &copy; 2025&nbsp;Taiwan Television Enterprise, Ltd. All Rights Reserved.</p>\r\n<a href=\"https://accessibility.moda.gov.tw/Applications/Detail?category=20250521151401\" title=\"無障礙標籤\"><img alt=\"無障礙標籤\" class=\"accessibility_img\" src=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAI4AAAAyCAYAAACK9eMGAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAABAtSURBVHhe7Z19bFX1GcefewvjpZUCYquglLcpMRQ0KEqm+Icl22TKosIf4kt8GTNR3MAZ0YiLMidLRDLRGREkviabb7yoC8MmistggIiAThwUq5GVqoMiFRj03j2f3+1z+7un5/be21bTxvMkpu05v/P7/c7zfH/P+8HYJb8rWiGx2FSJKOJA3hxIPhb76QNFR2IS65X3M9HA7z0HkpJsiF3yQI/k954TEQMK4oAC54sIOAWxLBoMByLgRDhoFwci4LSLbdFDEXAiDLSLAxFw2sW26KEIOBEGQjlw+EBLoN2nf6zVmAg431PgGDAON4iccoLIQI2TBvdLSllvkRP0vyEDRDbuEVmxJSZH4iKDz4pLUY8WZuUNnKqx18qb257pNDYz37bat6W+oTbnnMW9SqW8/zCp2fd+zrE2oHLoRTp+qzQeVc50kKaee5u++9OdMlcHt5L3420BY0h/BcZA/a9/0gGkLar+V0xueTYmg0aKlJ6qCGqmvICDEOZcukxuXTo+b+bNuPBeuerCeemFXnhnvrxf+1b6719OXihrFYgGBgBkIBpRPk76KliMSnr3l59P+JXMf/FymToBIT4jk8del54fgMx9ripjb6/ffUymLxzkAPeLqoVtMueu56vS94Nrc+MPV1fLnc9dnDHHNwrIQoCct8TzHNhZwMhnuQnzVduUxWTgsBaTlRM4nPanbtklCC8XLVl7u6zc9IgbBnCg59+5XxbfuNkJe+IZrcthzI9W4ESbRkMbAVaEuOHjVbKv4RMnfITFmLU61kB2/umXOVDNDQgW4Ez5fU9h/hHlZ7m9LLj6TQewmQpa5kHwjUcPZACAtVmXeau3PdvqlVPAfdo9E9TAvPOYoZMUrBXuPoclH3CVlVbI7J8tEx/AwYVH90nIyceS0kdvjD5FpJ/+ko/GyCazPQdjcui4SM3XMWk81vxT/4aK1STNHN0kZSymdO3SuPy7qQDg8ELzrnxJGTFcVm58xIHABOIDw675m7T76z9eqXO8LNc/NqpZeNXy/Lr7Zfunb7u/lysoOc1Bk+XPD4hmTLrXgYPfx1ZcJIeOHJCy0qFSpZpn1rJzWmkr0xLMO+fSpySZTLrnMI8Ao17B2Hj0YAZgbf+AbYFqGQ6BDw4Ax/qsFyT2C6geXn2DNB5p0H1d68Dn7y1MiMZjwA3Qg1Sslxac0yQj1P8ohLb/N6Ud0j/3p/7e3QyUXHPNHJ2QqRWJNHB2HlVzNSpPjcOLl5cOS2ub9gAHxiC84t6lMrxsnDuN0L4DtTpvqQq/xXfxTxxgW6FgBWAIct60V9xzjQoY9sFJRjj4H/yNZoJMuICDMdxjLoRiAAcUgBcgQYyBGMc750usOf+lK9zwv9z+pZvTNC7XOBS8g3/NnxuwXXbuLMcf9hsGnNljmqRqSGvQZAPGtmbAhL3DoS8T8r/GmPTuJ9J3QOtIKWNvIxNy1agW4Gz7SjWcOshGbZoqs/eTVUAQPomd5LBrjNnx6To31jQGfg7MNcHmKxQEcf2jI9N+C4BYv3OVAxKnvrJikpsKUGFGV25anDYLCB8QmOkEMICDPfETwG1XzQNo2a8Bx/bG/MqYNrdq72mD4NW+A2ixFmc8DEz+pJhw1kZDYUbDgDN2YFIAT+OxmDy/Oy7r69sWeLZNf7q5SY4paIwGVGSanuBzMzoCHBiMxqlsPpkwGyBgu8OusbgJwYCDf4JWwMxgMrKdaJ9prIvN365CRSA4uQhhd91W936cYDMHaBV8pyVr56SBA8hYk5OMiQQI2Yj9+WaSsfOmvdymb8Ke5r94Rdrchs3N+phXAopckSNrZgOOOxxqrkrU79h3OHMlTAnwXlXbogkYUTUkIX11fPXn6r8cj8mBzxLyVU3rXZ46Pia9SmLq0yRl6rCk1BwU2VCfmqtDwLGlwvyZfH0cgIRpWL9zpRPwvgN7nObyCS3mAwcVj4njGs/ijE48faq7hhYhisK3QdPs1t+JsMxkMK897zvAF1emtGaQgg4pQpw5+SF5QtfJRkSES9b+JitwDPj5atpcwAkFpoIGP8QdpNqYLPmoyP0OaGaPSV1/U4GzaEeRfL41IarUWtGJI0T6nxaXeWc3yfllKQ07/724A0+XAA4gMw3F5tBcPqHFDDiYHk4qziJaCuCs2PhHpwHQWBY9cZ15cHbN0WbOlOAXOk2FtsGPAbQWWfnrBiMqe57UQ1s5K4Dx8OobQ4GDpmH9Ra/dmHfeqz3A8X2fDWq+5r+XAo4vcPyguZuKcmqcxROPq/Od4sySj+IKxA4CB+YTBvsOrUUmYdd8f8HXSDCyuFd/l1MhuvEF7V5WgRW07wDDgIPGQcNUaqhrDi8hOMDB9DEfmggyDYWpY04TZOvzlrpi5szuI8TZly7NCZxFq29q9R6siVZl3/mE4f6abZmqsL1jXuZUpjQLvk+NhteQXSekXrIzdb1Jw/j/bEvI0UMtPk5JuUj56JRZImKbeUbCmUKAg3nzAXjXyzH5665Y/s6x5UAACVGQ25hGQvgX/u9cg2CW2XMDDppmeNlYdwK5j88E+bkU/g6CCQA8t+4+wSzMWnauc4Lxc2yemZMfbqVxGMN1xgRTBBZlWUSFtgk6s+6dvLyPCczyP74Ag1lpC8cLBQ1ztkfjhIGprWuA5+u6pBw/KvKDEs0DnZzpFwWf9YHzaHVMlm4uADgOjap18P5xUIvVp8AfwQRw0mEWeQpONeobpllUYcDBlCAk7hOOG1ku5ZBnfH1/w0wRz7GeJebwdTAjF4+9xiXogqbK5veBgyZgPfZHWE/YDNjZowHRwOzv0eYyLRtk7p76952mM1DjaNsBs7HV259x++3Vs6+8ckeDPPLGzbJm67KMqb4L4BQKtA4Bhxe6RxOAT755e1p1mymAGeb0EuVYTsXA45sqAyDmyiiocYJax0wVAocIr4lQMHfsqb7hUxVYP+do12sYXFO/LSN6MeAAGp4h6qKMgf9iZoa50VDmN+F8m0b0GR2mcbhvERnP4aCHkQG7KN5DD9gsebdmrdR+sSNjqD0fTAtkE/bRQ0n5clfSOby9+ySldERMSga1aJAyvVaikZiZL5sn23UnHzVXhzSDXH84Zc46BBwYy0v5ORgTJGYneB+gmckBSGR3s+VvwoDjM8ovqgJCMtC2JloHhxk/xyjIdAOelTQMJJgnQFRI8dPmKvTUfhvjMTm1/9QwXEsAPlloXTkgKQsmNLlbi3bENbJq8WMe1Aw0gHphV9z5RelDrOWFqRUp4Ny1ucgBbqJGWfdotAW1y1R9Gy8fzdl+DhysS8gXO1s/b85uWFQV1CAWbdksflRloCLx+OC5EXDaL6ku9mQ24JQOEa0lxZ3JWaACJ6oKapyw67weiURyQo1a5Lz1H0XOXAWBg9YZeVGeJYcgz1CDU4clpLy3qjUN2UgwVe/N9M4tC8nYcrW1oBu1aLazi8mh220nm6k6ZWwso/6EHAirg5Tv9U4Djp+R9Ddj2UmusSlQbckkG+fbzm4nqS64YZzjuh0JDa31+9si7dobnekcd8aWOwU4vsMVtinLNvqp6+A4wHPDuqLQU9AZLxrNkZsDAK5JzVGvYpGinm0XSzsFOMsnHU839aBhMD04YVbuBxSPfRiXO8elMpnYyvlbUinwOZUtDUG+dsr9mtGIXBzgQO870hJC23iuN6pfa+E45q3ug1T4DqGlaJGgwGmWYriWHPZokdPMW4eB45soADG9uqVj+fUfN7eM6er7NSM5oPmfLchWdGOT16vWifydXJDIfZ8OPUJoaO7GItne3KjlR1V2/ctdCWn4PHPOHuqnVpyXOtwWVflWocPAwWep1NDMaMqacOD422oLOP693OyJRmTjgC8XPy8Tdr12Q5Pzh4JkDrWvAAxsPnCsYb2gqMqflIUxN/g0hG9hnWmMAbmLtmuBTYtqvEh5c+8q9+j5mLW+h0vT02oZ7JWxsoO1XvrZZjLYwdIFc5LWpwJOUpHmLJ+sLMBzYa0VrHfB6Cukf3GZvPbu4y4bTiHWJ5KP1ZqhJml477RX5aFV18nVk36b7lv2x5KUrNtfIyV9BoSu98aWJ2TK+Jtd470lIeHFbM1or9y4uM0eH38dswT1WpgkhDYTc35ZwhU/6SO+UyvjaPdsbRVDz4tJz94x11+M9vLzOz5wNmkvzzXad5w3cHI5xe3VB9PfOtE1LlE2oPHciqbMR+bZ2j8pZfi1HwqL1JoAiV99JvVPdpnSAnUon6iTQQDC+oH9+6x35cQ75KR+p8nja25zxVEa2jPBcJvLglPXWnHnIbl28TC5+/I/Z/RO2/hfT3nSlT/ImFO+SGWsF6bn5B0oc5CRt0NCOQXye4ray9uw577ZT3U88zD41fGwZzodOGgcOuPJ0aBxSDQFCV9o5Sdx57hVDU5mmDrG/qluhvzknDtCm765b5+2hJUFrD8HQRrt0fIHJ/380y/V0kSq9xiivOAEqICy5+yelUOo5geBQ0F3eHONjPETtaB7sjbsI9h8gbNKW1mhbAVMCsf2BQegL+TTo/aACvDsr02Bhy8z/U9dOh04qL15Z6ciJcjPRPI3WcrFE1NpaSNUp6lIuxZsuF59cJokSi5I99D4z3MS6eAL679lnN9NaM9RewIk1hVo162WRgWfav7I5s9kuM869M4gsElnTs/QOIxHK0CpNotx6caszgIO6z9607vOLKJ58u3fQROM7puUY3ooP1Czb/TZsbgcLuxDiDC8pK91msYJ1jdsBd+7DwOXY74mBpdflEqDQ7O2jncAyNaPC3CeUDCEFUitnybYv5ONC/TwoEHCCBOCmTx6/HAGcIKgxT8ClFTROws47AdNQ3uHNaG1Kcnmm37UlG38XlXGe5sbu/A3dx1IOcbxuPox9rsGVJ8d16YtvR9GWBMOPFSwj0MZfvmk1pVWf6Gg1vGjLn+cAcxCemvmtgZ0G8vp44QDkOA9nGM0Ae0Ufh8PzjEUdH75/AY/isp52NecI08+K1Tj0AqR8Y66H2st8YETto8xp13ofJxcpsqAw8982ykYi0CrBidc8/rwAr+1aguYezXHs7chBbDSviI/HNSivl7V78fvW1tgI5fF+H6uILgBi7w+3C9yx8YQp0cfsEKanwQM638J9g/7a+FY4q/4kRb3cY6hsF4a+y4rrOfYuvgGDxglP+jZRz6p3x76RYT/JcSEUVNkS83fZOhJZ4buo6T3APfFaZ025UPWURimIXl/KNdXEG0J3O5hWow4zMWpFI37QmLECS33/NRKPvMyZu6auGxV7VTQPzpgfk4u4NSpb/ONqj1C7TBCxVIgteprvpuOxn17HABgaC6Iz30pXhsBMIIgGuHDPvLL+e04EwW7w/xXwX8Zof9MRs3XIFvD6eYMZvB1MXvudDV3mH177Ihm/i44kBdwvouNRGt0Lw5EwOle8uoyu42A02VE0b02EgGne8mry+w2Ak6XEUX32kgEnO4lry6z2wg4XUYU3WsjEXC6l7y6zG61OFuv/7+qHn/XKsWPusyuoo10eQ4ocF79P6hHS8HAZBceAAAAAElFTkSuQmCC\" /></a></div>\r\n"
      };
    } else {
      this.FooterData = {
        "SiteUrl": "https://tavis.tw/gma/36th",
        "SiteLogo": "https://tavis.tw/gma/36th/Upload/Editor/95635b33-f644-44a6-9371-dc4a6ecaa672.webp",
        "FestivalHistory_Menu": [
          {
            "Menu": {
              "MLIId": 222,
              "MLId": 18,
              "Id": "03e3daa8-2319-495a-9ed0-2bf1541a60ca",
              "ParentId": "root",
              "Title": "2024",
              "Description": "",
              "IsVisable": true,
              "Image": "",
              "Color": "",
              "Type": 3,
              "CId": -1,
              "PId": -1,
              "Url": "https://tavis.tw/gma/35th/",
              "Blank": true,
              "Sort": 1,
              "CreateTime": "2025-04-17T15:26:50.47",
              "LastEditTime": "2025-04-17T15:31:32.983",
              "IsWinner": false
            },
            "SubMenus": null
          },
          {
            "Menu": {
              "MLIId": 223,
              "MLId": 18,
              "Id": "3e581b20-5ae7-4146-8d4c-fcb0d0a6d6b9",
              "ParentId": "root",
              "Title": "2023",
              "Description": "",
              "IsVisable": true,
              "Image": "",
              "Color": "",
              "Type": 3,
              "CId": -1,
              "PId": -1,
              "Url": "https://tavis.tw/gma/34th/",
              "Blank": true,
              "Sort": 2,
              "CreateTime": "2025-04-17T15:27:22.063",
              "LastEditTime": "2025-04-17T15:31:33",
              "IsWinner": false
            },
            "SubMenus": null
          },
          {
            "Menu": {
              "MLIId": 224,
              "MLId": 18,
              "Id": "ee965115-4120-4af7-a532-9b6697145fa2",
              "ParentId": "root",
              "Title": "2022",
              "Description": "",
              "IsVisable": true,
              "Image": "",
              "Color": "",
              "Type": 3,
              "CId": -1,
              "PId": -1,
              "Url": "https://tavis.tw/gma/33rd/",
              "Blank": true,
              "Sort": 3,
              "CreateTime": "2025-04-17T15:27:45.05",
              "LastEditTime": "2025-04-17T15:31:33",
              "IsWinner": false
            },
            "SubMenus": null
          },
          {
            "Menu": {
              "MLIId": 225,
              "MLId": 18,
              "Id": "49a0e9bb-80d5-4788-84f3-fd307e877d4a",
              "ParentId": "root",
              "Title": "2021",
              "Description": "",
              "IsVisable": true,
              "Image": "",
              "Color": "",
              "Type": 3,
              "CId": -1,
              "PId": -1,
              "Url": "https://tavis.tw/gma/32nd/",
              "Blank": false,
              "Sort": 4,
              "CreateTime": "2025-04-17T15:28:46.007",
              "LastEditTime": "2025-04-17T15:31:33",
              "IsWinner": false
            },
            "SubMenus": null
          },
          {
            "Menu": {
              "MLIId": 226,
              "MLId": 18,
              "Id": "f0183c43-7e65-46a8-a28a-edd7ccd84424",
              "ParentId": "root",
              "Title": "2020",
              "Description": "",
              "IsVisable": true,
              "Image": "",
              "Color": "",
              "Type": 3,
              "CId": -1,
              "PId": -1,
              "Url": "https://tavis.tw/gma/31st/",
              "Blank": false,
              "Sort": 5,
              "CreateTime": "2025-04-17T15:29:01.74",
              "LastEditTime": "2025-04-17T15:31:33",
              "IsWinner": false
            },
            "SubMenus": null
          },
          {
            "Menu": {
              "MLIId": 227,
              "MLId": 18,
              "Id": "b047e51d-234a-423b-98c9-fe9a832023fc",
              "ParentId": "root",
              "Title": "2019",
              "Description": "",
              "IsVisable": true,
              "Image": "",
              "Color": "",
              "Type": 3,
              "CId": -1,
              "PId": -1,
              "Url": "https://tavis.tw/gma/30th/",
              "Blank": true,
              "Sort": 6,
              "CreateTime": "2025-04-17T15:29:15.303",
              "LastEditTime": "2025-04-17T15:31:33",
              "IsWinner": false
            },
            "SubMenus": null
          },
          {
            "Menu": {
              "MLIId": 228,
              "MLId": 18,
              "Id": "666ada21-f03d-4659-9422-880b54a7f625",
              "ParentId": "root",
              "Title": "2018",
              "Description": "",
              "IsVisable": true,
              "Image": "",
              "Color": "",
              "Type": 3,
              "CId": -1,
              "PId": -1,
              "Url": "https://tavis.tw/gma/29th/",
              "Blank": true,
              "Sort": 7,
              "CreateTime": "2025-04-17T15:29:46.173",
              "LastEditTime": "2025-04-17T15:31:33",
              "IsWinner": false
            },
            "SubMenus": null
          },
          {
            "Menu": {
              "MLIId": 229,
              "MLId": 18,
              "Id": "adfc1766-e6ab-4328-9a6e-e5006be52eb0",
              "ParentId": "root",
              "Title": "2017",
              "Description": "",
              "IsVisable": true,
              "Image": "",
              "Color": "",
              "Type": 3,
              "CId": -1,
              "PId": -1,
              "Url": "https://tavis.tw/gma/28th/",
              "Blank": true,
              "Sort": 8,
              "CreateTime": "2025-04-17T15:30:10.92",
              "LastEditTime": "2025-04-17T15:31:33",
              "IsWinner": false
            },
            "SubMenus": null
          },
          {
            "Menu": {
              "MLIId": 230,
              "MLId": 18,
              "Id": "6f9c4d5e-2a01-4a59-b518-2d54ea793961",
              "ParentId": "root",
              "Title": "2016",
              "Description": "",
              "IsVisable": true,
              "Image": "",
              "Color": "",
              "Type": 3,
              "CId": -1,
              "PId": -1,
              "Url": "https://tavis.tw/gma/27th/",
              "Blank": true,
              "Sort": 9,
              "CreateTime": "2025-04-17T15:30:36.213",
              "LastEditTime": "2025-04-17T15:31:33",
              "IsWinner": false
            },
            "SubMenus": null
          },
          {
            "Menu": {
              "MLIId": 231,
              "MLId": 18,
              "Id": "7ca87c57-fb32-40b0-a1ea-71d3b2e91a54",
              "ParentId": "root",
              "Title": "2015",
              "Description": "",
              "IsVisable": true,
              "Image": "",
              "Color": "",
              "Type": 3,
              "CId": -1,
              "PId": -1,
              "Url": "https://tavis.tw/gma/26th/",
              "Blank": true,
              "Sort": 10,
              "CreateTime": "2025-04-17T15:30:54.133",
              "LastEditTime": "2025-04-17T15:31:33",
              "IsWinner": false
            },
            "SubMenus": null
          },
          {
            "Menu": {
              "MLIId": 232,
              "MLId": 18,
              "Id": "d73bd9cd-2a2d-4bb1-a412-8a59f2c3f90a",
              "ParentId": "root",
              "Title": "2014",
              "Description": "",
              "IsVisable": true,
              "Image": "",
              "Color": "",
              "Type": 3,
              "CId": -1,
              "PId": -1,
              "Url": "https://tavis.tw/gma/25th/",
              "Blank": true,
              "Sort": 11,
              "CreateTime": "2025-04-17T15:31:15.27",
              "LastEditTime": "2025-04-17T15:31:33",
              "IsWinner": false
            },
            "SubMenus": null
          }
        ],
        "Links_Menu": [
          {
            "Menu": {
              "MLIId": 294,
              "MLId": 22,
              "Id": "04d8263a-87b5-41fe-8e40-dd6cb145a291",
              "ParentId": "root",
              "Title": "主辦單位 Organizer",
              "Description": "",
              "IsVisable": true,
              "Image": "/Upload/Editor/1d6e2d69-d651-4fa8-b19f-fc656f512979.webp",
              "Color": "",
              "Type": 0,
              "CId": -1,
              "PId": -1,
              "Url": "",
              "Blank": false,
              "Sort": 1,
              "CreateTime": "2025-04-30T14:03:03.4",
              "LastEditTime": "2025-05-08T17:32:49.17",
              "IsWinner": false
            },
            "SubMenus": null
          },
          {
            "Menu": {
              "MLIId": 417,
              "MLId": 22,
              "Id": "aa23d201-a184-4b89-a023-a6a33f029466",
              "ParentId": "root",
              "Title": "合辦單位 Co-organizer",
              "Description": "",
              "IsVisable": true,
              "Image": "",
              "Color": "",
              "Type": 0,
              "CId": -1,
              "PId": -1,
              "Url": "",
              "Blank": false,
              "Sort": 2,
              "CreateTime": "2025-05-08T17:23:59.29",
              "LastEditTime": "2025-05-08T17:32:49.17",
              "IsWinner": false
            },
            "SubMenus": [
              {
                "MLIId": 421,
                "MLId": 22,
                "Id": "32131b1e-c66c-49cb-aca4-966d988b834a",
                "ParentId": "aa23d201-a184-4b89-a023-a6a33f029466",
                "Title": "文化部",
                "Description": "",
                "IsVisable": true,
                "Image": "/Upload/Editor/83f93e28-f793-4af7-b344-3b4c27761564.webp",
                "Color": "",
                "Type": 0,
                "CId": -1,
                "PId": -1,
                "Url": "",
                "Blank": false,
                "Sort": 3,
                "CreateTime": "2025-05-08T17:25:06.287",
                "LastEditTime": "2025-05-08T17:32:49.17",
                "IsWinner": false
              },
              {
                "MLIId": 422,
                "MLId": 22,
                "Id": "c201e6c3-2d85-439d-89a5-0cd33df0eb84",
                "ParentId": "aa23d201-a184-4b89-a023-a6a33f029466",
                "Title": "文化局",
                "Description": "",
                "IsVisable": true,
                "Image": "/Upload/Editor/c6b8e10e-2e48-4fdf-8c1d-e87dc2e17480.webp",
                "Color": "",
                "Type": 0,
                "CId": -1,
                "PId": -1,
                "Url": "",
                "Blank": false,
                "Sort": 4,
                "CreateTime": "2025-05-08T17:25:07.14",
                "LastEditTime": "2025-05-08T17:32:49.17",
                "IsWinner": false
              }
            ]
          },
          {
            "Menu": {
              "MLIId": 418,
              "MLId": 22,
              "Id": "be40f830-48dd-49cc-a2b5-b56c2514a6ae",
              "ParentId": "root",
              "Title": "承辦單位 Executive organizer",
              "Description": "",
              "IsVisable": true,
              "Image": "/Upload/Editor/f75c453a-d96d-48ca-b2ad-daeacc8785ea.webp",
              "Color": "",
              "Type": 0,
              "CId": -1,
              "PId": -1,
              "Url": "",
              "Blank": false,
              "Sort": 5,
              "CreateTime": "2025-05-08T17:24:00.15",
              "LastEditTime": "2025-05-08T17:32:49.17",
              "IsWinner": false
            },
            "SubMenus": null
          },
          {
            "Menu": {
              "MLIId": 419,
              "MLId": 22,
              "Id": "e4ea20b8-9858-40ad-bf82-c05f67d4cc6b",
              "ParentId": "root",
              "Title": "典禮製作統籌 Ceremony Production",
              "Description": "",
              "IsVisable": true,
              "Image": "/Upload/Editor/2c45148c-dc00-45f9-8fce-f7adbfa70dba.webp",
              "Color": "",
              "Type": 0,
              "CId": -1,
              "PId": -1,
              "Url": "",
              "Blank": false,
              "Sort": 6,
              "CreateTime": "2025-05-08T17:24:00.963",
              "LastEditTime": "2025-05-08T17:32:49.17",
              "IsWinner": false
            },
            "SubMenus": null
          },
          {
            "Menu": {
              "MLIId": 420,
              "MLId": 22,
              "Id": "61375f17-6610-4039-83f9-8ceb550cde0e",
              "ParentId": "root",
              "Title": "直播平台 Live Streaming Platform",
              "Description": "",
              "IsVisable": true,
              "Image": "",
              "Color": "",
              "Type": 0,
              "CId": -1,
              "PId": -1,
              "Url": "",
              "Blank": false,
              "Sort": 7,
              "CreateTime": "2025-05-08T17:24:01.76",
              "LastEditTime": "2025-05-08T17:32:49.17",
              "IsWinner": false
            },
            "SubMenus": [
              {
                "MLIId": 423,
                "MLId": 22,
                "Id": "540ed6d4-33ae-4e6e-9c9e-68f111c0911b",
                "ParentId": "61375f17-6610-4039-83f9-8ceb550cde0e",
                "Title": "LINE TODAY",
                "Description": "",
                "IsVisable": true,
                "Image": "/Upload/Editor/8a028c5a-dabe-47f9-a457-7eee2b015d42.webp",
                "Color": "",
                "Type": 0,
                "CId": -1,
                "PId": -1,
                "Url": "",
                "Blank": false,
                "Sort": 8,
                "CreateTime": "2025-05-08T17:25:38.32",
                "LastEditTime": "2025-05-08T17:32:49.17",
                "IsWinner": false
              },
              {
                "MLIId": 424,
                "MLId": 22,
                "Id": "d8e63267-fde5-4fa7-9cce-b6e7313aa54a",
                "ParentId": "61375f17-6610-4039-83f9-8ceb550cde0e",
                "Title": "LINE MUSIC",
                "Description": "",
                "IsVisable": true,
                "Image": "/Upload/Editor/acd101b5-2688-4c3d-9bd3-f18f6df8b381.webp",
                "Color": "",
                "Type": 0,
                "CId": -1,
                "PId": -1,
                "Url": "",
                "Blank": false,
                "Sort": 9,
                "CreateTime": "2025-05-08T17:25:39.18",
                "LastEditTime": "2025-05-08T17:32:49.17",
                "IsWinner": false
              }
            ]
          },
          {
            "Menu": {
              "MLIId": 425,
              "MLId": 22,
              "Id": "e3b476a0-2548-4e96-8470-2240cba0c575",
              "ParentId": "root",
              "Title": "金曲指定電信 Designated Telecom",
              "Description": "",
              "IsVisable": true,
              "Image": "/Upload/Editor/b4170444-21fc-4e22-9ab0-337dd344bde0.webp",
              "Color": "",
              "Type": 0,
              "CId": -1,
              "PId": -1,
              "Url": "",
              "Blank": false,
              "Sort": 10,
              "CreateTime": "2025-05-08T17:29:50.81",
              "LastEditTime": "2025-05-08T17:32:49.187",
              "IsWinner": false
            },
            "SubMenus": null
          },
          {
            "Menu": {
              "MLIId": 426,
              "MLId": 22,
              "Id": "559efd0f-4f7b-4bed-ab9f-67a8b35823b5",
              "ParentId": "root",
              "Title": "金曲指定禮車 Designated Limousine",
              "Description": "",
              "IsVisable": true,
              "Image": "/Upload/Editor/58f18185-8cb5-42ed-ac3f-0c95ad30a3e2.webp",
              "Color": "",
              "Type": 0,
              "CId": -1,
              "PId": -1,
              "Url": "",
              "Blank": false,
              "Sort": 11,
              "CreateTime": "2025-05-08T17:29:51.373",
              "LastEditTime": "2025-05-08T17:32:49.187",
              "IsWinner": false
            },
            "SubMenus": null
          },
          {
            "Menu": {
              "MLIId": 427,
              "MLId": 22,
              "Id": "23f77e94-e670-4a77-b0a4-0b721301f4ba",
              "ParentId": "root",
              "Title": "金曲指定航空 Designated Airline",
              "Description": "",
              "IsVisable": true,
              "Image": "/Upload/Editor/6e498515-66c3-4295-ad9d-617f95da2e23.webp",
              "Color": "",
              "Type": 0,
              "CId": -1,
              "PId": -1,
              "Url": "",
              "Blank": false,
              "Sort": 12,
              "CreateTime": "2025-05-08T17:29:52",
              "LastEditTime": "2025-05-08T17:32:49.187",
              "IsWinner": false
            },
            "SubMenus": null
          },
          {
            "Menu": {
              "MLIId": 428,
              "MLId": 22,
              "Id": "ec378853-1f3c-4fee-a8a1-eed94d2ff5d3",
              "ParentId": "root",
              "Title": "聯合贊助 Co-sponsors",
              "Description": "",
              "IsVisable": true,
              "Image": "",
              "Color": "",
              "Type": 0,
              "CId": -1,
              "PId": -1,
              "Url": "",
              "Blank": false,
              "Sort": 13,
              "CreateTime": "2025-05-08T17:30:21.913",
              "LastEditTime": "2025-05-08T17:32:49.187",
              "IsWinner": false
            },
            "SubMenus": [
              {
                "MLIId": 432,
                "MLId": 22,
                "Id": "d32832fb-db1e-4502-ad87-4735bdfd7c47",
                "ParentId": "ec378853-1f3c-4fee-a8a1-eed94d2ff5d3",
                "Title": "CITY PRIMA",
                "Description": "",
                "IsVisable": true,
                "Image": "/Upload/Editor/e77c58de-c834-4b11-9a19-1fd26f387631.webp",
                "Color": "",
                "Type": 0,
                "CId": -1,
                "PId": -1,
                "Url": "",
                "Blank": false,
                "Sort": 14,
                "CreateTime": "2025-05-08T17:30:37.163",
                "LastEditTime": "2025-05-08T17:32:49.187",
                "IsWinner": false
              },
              {
                "MLIId": 433,
                "MLId": 22,
                "Id": "06642472-63fd-48ac-afbd-db8e5cd35742",
                "ParentId": "ec378853-1f3c-4fee-a8a1-eed94d2ff5d3",
                "Title": "麥當勞",
                "Description": "",
                "IsVisable": true,
                "Image": "/Upload/Editor/f4e56a0a-679a-4eb9-ae7a-2d92a2561d08.webp",
                "Color": "",
                "Type": 0,
                "CId": -1,
                "PId": -1,
                "Url": "",
                "Blank": false,
                "Sort": 15,
                "CreateTime": "2025-05-08T17:30:38.023",
                "LastEditTime": "2025-05-08T17:32:49.187",
                "IsWinner": false
              },
              {
                "MLIId": 434,
                "MLId": 22,
                "Id": "6ee8400a-25bc-40bf-98d3-efb2d2add3dc",
                "ParentId": "ec378853-1f3c-4fee-a8a1-eed94d2ff5d3",
                "Title": "舒酸定",
                "Description": "",
                "IsVisable": true,
                "Image": "/Upload/Editor/088423bb-4281-4d09-b1aa-d860a7f79221.webp",
                "Color": "",
                "Type": 0,
                "CId": -1,
                "PId": -1,
                "Url": "",
                "Blank": false,
                "Sort": 16,
                "CreateTime": "2025-05-08T17:30:38.73",
                "LastEditTime": "2025-05-08T17:32:49.187",
                "IsWinner": false
              }
            ]
          },
          {
            "Menu": {
              "MLIId": 429,
              "MLId": 22,
              "Id": "16d72a99-3fd1-493b-947a-450ec321fe5a",
              "ParentId": "root",
              "Title": "媒體協辦 Media Collaborators",
              "Description": "",
              "IsVisable": true,
              "Image": "",
              "Color": "",
              "Type": 0,
              "CId": -1,
              "PId": -1,
              "Url": "",
              "Blank": false,
              "Sort": 17,
              "CreateTime": "2025-05-08T17:30:22.71",
              "LastEditTime": "2025-05-08T17:32:49.187",
              "IsWinner": false
            },
            "SubMenus": [
              {
                "MLIId": 435,
                "MLId": 22,
                "Id": "e0c79cef-840c-44dc-b24e-6e6ef517d0b4",
                "ParentId": "16d72a99-3fd1-493b-947a-450ec321fe5a",
                "Title": "非凡電視台",
                "Description": "",
                "IsVisable": true,
                "Image": "/Upload/Editor/12cb59d1-e965-4c90-9f35-355d5aea63cb.webp",
                "Color": "",
                "Type": 0,
                "CId": -1,
                "PId": -1,
                "Url": "",
                "Blank": false,
                "Sort": 18,
                "CreateTime": "2025-05-08T17:31:01.28",
                "LastEditTime": "2025-05-08T17:32:49.187",
                "IsWinner": false
              },
              {
                "MLIId": 436,
                "MLId": 22,
                "Id": "3d9d0708-d208-4268-82c7-1d4da504bcc5",
                "ParentId": "16d72a99-3fd1-493b-947a-450ec321fe5a",
                "Title": "ICRT",
                "Description": "",
                "IsVisable": true,
                "Image": "/Upload/Editor/4dbf4306-9be0-4d59-82b8-acdb391fc28c.webp",
                "Color": "",
                "Type": 0,
                "CId": -1,
                "PId": -1,
                "Url": "",
                "Blank": false,
                "Sort": 19,
                "CreateTime": "2025-05-08T17:31:02.923",
                "LastEditTime": "2025-05-08T17:32:49.2",
                "IsWinner": false
              }
            ]
          }
        ],
        "Festival_Links_Menu": [
          {
            "Menu": {
              "MLIId": 308,
              "MLId": 23,
              "Id": "b125a2ee-f7a3-4a2b-8e3d-8de2d981c177",
              "ParentId": "root",
              "Title": "主辦單位 Organizer",
              "Description": "",
              "IsVisable": true,
              "Image": "/Upload/Editor/89397acd-d1d2-451f-b835-9063ad60ac40.webp",
              "Color": "",
              "Type": 0,
              "CId": -1,
              "PId": -1,
              "Url": "",
              "Blank": false,
              "Sort": 1,
              "CreateTime": "2025-04-30T16:12:23.747",
              "LastEditTime": "2025-05-08T17:43:37.863",
              "IsWinner": false
            },
            "SubMenus": null
          },
          {
            "Menu": {
              "MLIId": 309,
              "MLId": 23,
              "Id": "5da3ef9d-a9a7-44f8-aadd-b43a5dd16858",
              "ParentId": "root",
              "Title": "合辦單位 Co-Organizer",
              "Description": "",
              "IsVisable": true,
              "Image": "/Upload/Editor/e1199baa-0871-4747-8375-58da25255493.webp",
              "Color": "",
              "Type": 0,
              "CId": -1,
              "PId": -1,
              "Url": "",
              "Blank": false,
              "Sort": 2,
              "CreateTime": "2025-04-30T16:13:14.66",
              "LastEditTime": "2025-05-08T17:43:37.863",
              "IsWinner": false
            },
            "SubMenus": null
          },
          {
            "Menu": {
              "MLIId": 310,
              "MLId": 23,
              "Id": "47efc34c-d841-4b1a-86ef-dc08ccca588e",
              "ParentId": "root",
              "Title": "承辦單位 Executive Organizer",
              "Description": "",
              "IsVisable": true,
              "Image": "/Upload/Editor/ee74a20d-dae9-43f3-acef-0a6cc5ba5b0d.webp",
              "Color": "",
              "Type": 0,
              "CId": -1,
              "PId": -1,
              "Url": "",
              "Blank": false,
              "Sort": 3,
              "CreateTime": "2025-04-30T16:13:44.383",
              "LastEditTime": "2025-05-08T17:43:37.863",
              "IsWinner": false
            },
            "SubMenus": null
          },
          {
            "Menu": {
              "MLIId": 311,
              "MLId": 23,
              "Id": "1a2fb1a7-d100-4fc2-91e2-db420df57420",
              "ParentId": "root",
              "Title": "金曲指定電信 Designated Telecom",
              "Description": "",
              "IsVisable": true,
              "Image": "/Upload/Editor/b5f223ae-9305-49a7-9e71-8af10eedb676.webp",
              "Color": "",
              "Type": 0,
              "CId": -1,
              "PId": -1,
              "Url": "",
              "Blank": false,
              "Sort": 4,
              "CreateTime": "2025-04-30T16:14:34.23",
              "LastEditTime": "2025-05-08T17:43:37.863",
              "IsWinner": false
            },
            "SubMenus": null
          },
          {
            "Menu": {
              "MLIId": 437,
              "MLId": 23,
              "Id": "cb1b54ae-9ae0-46a6-97a4-d466535e8c61",
              "ParentId": "root",
              "Title": "金曲指定航空 Designated Airline",
              "Description": "",
              "IsVisable": true,
              "Image": "/Upload/Editor/2ebe8311-33e8-44ba-b608-477bfb60c40f.webp",
              "Color": "",
              "Type": 0,
              "CId": -1,
              "PId": -1,
              "Url": "",
              "Blank": false,
              "Sort": 5,
              "CreateTime": "2025-05-08T17:41:47.97",
              "LastEditTime": "2025-05-08T17:43:37.863",
              "IsWinner": false
            },
            "SubMenus": null
          },
          {
            "Menu": {
              "MLIId": 438,
              "MLId": 23,
              "Id": "b83f4050-28f5-45ba-a65a-564b5afaa78b",
              "ParentId": "root",
              "Title": "媒體協辦 Media Collaborators",
              "Description": "",
              "IsVisable": true,
              "Image": "",
              "Color": "",
              "Type": 0,
              "CId": -1,
              "PId": -1,
              "Url": "",
              "Blank": false,
              "Sort": 6,
              "CreateTime": "2025-05-08T17:42:25.19",
              "LastEditTime": "2025-05-08T17:43:37.863",
              "IsWinner": false
            },
            "SubMenus": [
              {
                "MLIId": 439,
                "MLId": 23,
                "Id": "62dca78a-704d-4312-a827-797f08e24b88",
                "ParentId": "b83f4050-28f5-45ba-a65a-564b5afaa78b",
                "Title": "非凡",
                "Description": "",
                "IsVisable": true,
                "Image": "/Upload/Editor/cfb37aea-491f-47f1-bd45-8cbfd46f68a9.webp",
                "Color": "",
                "Type": 0,
                "CId": -1,
                "PId": -1,
                "Url": "",
                "Blank": false,
                "Sort": 7,
                "CreateTime": "2025-05-08T17:42:37.97",
                "LastEditTime": "2025-05-08T17:43:37.88",
                "IsWinner": false
              },
              {
                "MLIId": 440,
                "MLId": 23,
                "Id": "8b79dae2-c979-4b3d-9030-f38f6fe30e29",
                "ParentId": "b83f4050-28f5-45ba-a65a-564b5afaa78b",
                "Title": "ICRT",
                "Description": "",
                "IsVisable": true,
                "Image": "/Upload/Editor/ccc1343b-b148-41c9-b3a9-eece0d0e2b3e.webp",
                "Color": "",
                "Type": 0,
                "CId": -1,
                "PId": -1,
                "Url": "",
                "Blank": false,
                "Sort": 8,
                "CreateTime": "2025-05-08T17:43:19.233",
                "LastEditTime": "2025-05-08T17:43:37.88",
                "IsWinner": false
              }
            ]
          }
        ],
        "Right_Menu": [
          {
            "Menu": {
              "MLIId": 295,
              "MLId": 24,
              "Id": "90549816-2f68-40c3-aae9-6e5c9d7fc6bd",
              "ParentId": "root",
              "Title": "Facebook",
              "Description": "",
              "IsVisable": true,
              "Image": "/Upload/Editor/ce7d3f30-0234-4c66-8cc1-1298c184ca1c.svg",
              "Color": "",
              "Type": 3,
              "CId": -1,
              "PId": -1,
              "Url": "https://www.facebook.com/GMAGMF",
              "Blank": true,
              "Sort": 1,
              "CreateTime": "2025-04-30T14:07:14.247",
              "LastEditTime": "2025-04-30T14:27:08.097",
              "IsWinner": false
            },
            "SubMenus": null
          },
          {
            "Menu": {
              "MLIId": 296,
              "MLId": 24,
              "Id": "eded6482-e9e7-44c0-8e5d-dc1840868627",
              "ParentId": "root",
              "Title": "Youtube",
              "Description": "",
              "IsVisable": true,
              "Image": "/Upload/Editor/d4d197de-85c0-4b14-bad0-c88036840944.svg",
              "Color": "",
              "Type": 3,
              "CId": -1,
              "PId": -1,
              "Url": "https://www.youtube.com/channel/UC_r0QUJ6T4ZLaadqQcaA7qw",
              "Blank": true,
              "Sort": 2,
              "CreateTime": "2025-04-30T14:07:23.437",
              "LastEditTime": "2025-04-30T14:27:08.097",
              "IsWinner": false
            },
            "SubMenus": null
          },
          {
            "Menu": {
              "MLIId": 297,
              "MLId": 24,
              "Id": "6546105e-eb10-4d8b-89bc-a1d5d845a80b",
              "ParentId": "root",
              "Title": "X",
              "Description": "",
              "IsVisable": true,
              "Image": "/Upload/Editor/6594b620-c776-42a6-a5da-ce51f9fda211.svg",
              "Color": "",
              "Type": 3,
              "CId": -1,
              "PId": -1,
              "Url": "https://twitter.com/GoldenMelody",
              "Blank": true,
              "Sort": 3,
              "CreateTime": "2025-04-30T14:07:41.657",
              "LastEditTime": "2025-04-30T14:27:08.113",
              "IsWinner": false
            },
            "SubMenus": null
          },
          {
            "Menu": {
              "MLIId": 298,
              "MLId": 24,
              "Id": "969892e2-7220-4611-9558-95118a6d616e",
              "ParentId": "root",
              "Title": "IG",
              "Description": "",
              "IsVisable": true,
              "Image": "/Upload/Editor/302967d7-81bf-47e1-aa93-08b82370dcf8.svg",
              "Color": "",
              "Type": 3,
              "CId": -1,
              "PId": -1,
              "Url": "https://www.instagram.com/gmamusic.official/?hl=zh-tw",
              "Blank": true,
              "Sort": 4,
              "CreateTime": "2025-04-30T14:07:56.473",
              "LastEditTime": "2025-04-30T14:27:08.113",
              "IsWinner": false
            },
            "SubMenus": null
          }
        ],
        "Footer_Text": "<div class=\"box\">\r\n<p>臺灣電視事業股份有限公司版權所有 &copy; 2024 Taiwan Television Enterprise, Ltd. All Rights Reserved.</p>\r\n<a href=\"https://accessibility.moda.gov.tw/Applications/Detail?category=20250521151401\" target=\"_blank\" title=\"無障礙標籤\"><img alt=\"無障礙標籤\" class=\"accessibility_img\" src=\"data:image/png;base64,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\" /></a></div>\r\n"
      };
    }
  },
  mounted: function () {
    if ($cookies.isKey("gma_the_site_lang")) {
      i18n.locale = $cookies.get("gma_the_site_lang");
      this.local = $cookies.get("gma_the_site_lang");
    } else {
      i18n.locale = "zh_tw";
      this.local = "zh_tw";
    }
    let that = this;
    // 監聽頁面滾動
    window.addEventListener('scroll', function () {
      // 判斷滾動高度，若大於100px則顯示top-bar按鈕
      if (window.scrollY > 500) {
        that.isFloat = true;
        that.isTop = true;
      } else {
        that.isFloat = false;
        that.isTop = false;
      }
    });
  },
  methods: {
    changeLang(lang) {
      $cookies.set("gma_the_site_lang", lang, "30d");
      location.reload();
    },
    gotoCategoryByCId: function (CId) {
      this.$router.push({
        name: "Category",
        params: { CId: CId },
      });
    },
    gotoPostByPId: function (PId) {
      this.$router.push({
        name: "Post",
        params: { PId: PId },
      });
    },
    gotoUrl: function (Url, Blank) {
      if (Blank) {
        window.open(Url, "_blank");
      } else {
        location.href = Url;
      }
    },
    goto: function (MenuData) {
      if (MenuData.Type == 1) {
        this.gotoCategoryByCId(MenuData.CId);
      } else if (MenuData.Type == 2) {
        this.gotoPostByPId(MenuData.PId);
      } else if (MenuData.Type == 3) {
        this.gotoUrl(MenuData.Url, MenuData.Blank);
      }
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    },
    getLink: function (MenuData) {
      if (MenuData.Type == 1) {
        const routeData = this.$router.resolve({
          name: "Category",
          params: { CId: MenuData.CId },
        });
        return routeData;
      } else if (MenuData.Type == 2) {
        const routeData = this.$router.resolve({
          name: "Post",
          params: { PId: MenuData.PId },
        });
        return routeData;
      } else if (MenuData.Type == 3) {
        return MenuData.Url;
      }
      return 'javascript:void(0)';
    },
  },
};
</script>
